import { PosBffApi } from '@kinderlabs-pos/apis/pos';
import { VaunceAppV2AppTicketType } from '@kinderlabs-pos/shared-data-type';
import { QueryClient } from '@kinderlabs-pos/state';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const VaunceAppTicketKeys = createQueryKeys('AppTickets', {
	search: ({ search }: { search: string }) => ({
		queryKey: [search],
		queryFn: async () => {
			if (!search) return null;
			return PosBffApi.search앱티켓과쿠폰({ search });
		},
	}),
	history: (ticketId: string, ticketType: VaunceAppV2AppTicketType) => ({
		queryKey: [ticketId, ticketType],
		queryFn: async () => {
			return (await PosBffApi.getAppTicketHistory({ ticketId, ticketType })).reverse();
		},
	}),
	forUser: (memberId: number) => ({
		queryKey: [memberId],
		queryFn: async () => {
			return await PosBffApi.getAppTicketForUser({ memberId });
		},
	}),
});

const invalidateQueries = () => {
	QueryClient.origin.invalidateQueries({ queryKey: VaunceAppTicketKeys._def });
};

export const VaunceAppTicketQueryState = {
	keys: VaunceAppTicketKeys,
	invalidateQueries,
};
